import { createIcon } from '@chakra-ui/icons';

export const Shrink = createIcon({
  displayName: 'Shrink',
  viewBox: '0 0 24 24',
  d: 'M24 1.67614L16.5241 9.15204H23.3918V11.5253H12.4747V0.608158H14.848V7.4759L22.3239 0L24 1.67614ZM0.608158 14.848V12.4747H11.5253V23.3918H9.15204V16.5241L1.67614 24L0 22.3239L7.4759 14.848H0.608158Z',
});
